export default __webpack_public_path__ + "static/numberFilter-e5afac0bbdd5ec280ec69aca2be4a1bb.gif";